// //import { ModalFooter, ModalHeader } from 'react-bootstrap'

// const Sidebar = () => {
//     return (
//       <div className='container-fluid'>
//         <div className='row'>
//           <div className='bd-dark col-auto col-md-3 min-vh-100 px-0'>
//             <a className='text-decoration-none text-white d-flex aling-items-center justify-content-center'>
//                 <span className='text-light fs-4 ms-2'>SideBar</span>
//             </a>
//             <ul className='nav flex-column nav nav-pills'>
//               <li className='nav-item text-white fs-4'>
//                 <a className='nav-link text-white fs-4' aria-current="page" href="">
//                   <i className='bi bi-speedometer2'>Dashboard</i>
//                   <span className="ms-2"></span>
//                 </a>
//               </li>
//               <li className='nav-item text-white fs-4'>
//                 <a className='nav-link text-white fs-5' aria-current="page" href="">
//                   <i className='bi bi-house'></i>
//                   <span className="ms-2">Home</span>
//                 </a>
//               </li>
//               <li className='nav-item text-white fs-4'>
//                 <a className='nav-link text-white fs-5' href='#' aria-current="page">
//                   <i className="bi bi-person-circle"></i>
//                   <span className="ms-2">Profile</span>
//                 </a>
//               </li>
//             </ul>
//             </div>


//         </div>
//       </div>
//     )
// }
  
// export default Sidebar;

// import { NavLink } from "react-router-dom";
// import { ListGroup, ListGroupItem } from "reactstrap";

// const Sidebar = (props) => {
//   return (
//     <>
//       <ListGroup className="mt-5">
//         <ListGroupItem>
//           <NavLink to={"/"}>Home</NavLink>
//         </ListGroupItem>
//         <ListGroupItem>
//           <NavLink to={"/superheroes"}>Super Heroes</NavLink>
//         </ListGroupItem>
//         <ListGroupItem>
//           <NavLink to={"/pokemon"}>Pokemon</NavLink>
//         </ListGroupItem>
//       </ListGroup>
//     </>
//   );
// };

// export default Sidebar;


// import React from 'react';
// import { Nav } from 'react-bootstrap';

// const Sidebar = () => {
//   return (
//     <div className="sidebar bg-dark" style={{ color: '#ffffff' }}>
//       <Nav defaultActiveKey="/home" className="flex-column">
//         <Nav.Link href="/home">Home</Nav.Link>
//         <Nav.Link href="/about">About</Nav.Link>
//         <Nav.Link href="/services">Services</Nav.Link>
//         <Nav.Link href="/contact">Contact</Nav.Link>
//       </Nav>
//     </div>
//   );
// };

//export default Sidebar;

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap-icons/font/bootstrap-icons.css';
import "../App.css"
import {SidebarData} from './SidebarData';

// function Sidebar() {
//    return <div className="Sidebar">{SidebarData.map((val, key) => {
//     return (
//       <div className="Sidebar-container">
//       <div className="container-fluid">
//       <div className="row">
//         <div className="col-auto min-vh-100 bd-dark">
//           <ul>
//             <il>
//               <a className='nav-link text-white fs-4 px-2' aria-current="page" href="">
//                 <i className='bi bi-speedometer2'>Dashboard</i>
//                 <span className="ms-2"></span>
//               </a>
//             </il>
//             <il>
//               <a className='nav-link text-white fs-5 px-2' aria-current="page" href="">
//                 <i className='bi bi-house'></i>
//                 <span className="ms-2">Add Parking Lot</span>
//               </a>
//             </il>
//             <il>
//               <a className='nav-link text-white fs-5 px-2' href='#' aria-current="page">
//                 <i className="bi bi-person-circle"></i>
//                 <span className="ms-2">List of Spaces</span>
//               </a>
//             </il>
//             <il>
//               <a className='nav-link text-white fs-5 px-2' href='./Map' aria-current="page">
//                 <i className="bi bi-person-circle"></i>
//                 <span className="ms-2">Map</span>
//               </a>
//             </il>
//             <il>
//               <a className='nav-link text-white fs-5 px-2' href='#' aria-current="page">
//                 <i className="bi bi-person-circle"></i>
//                 <span className="ms-2">Reservation</span>
//               </a>
//             </il>
//             <il>
//               <a className='nav-link text-white fs-5 px-2' href='#' aria-current="page">
//                 <i className="bi bi-person-circle"></i>
//                 <span className="ms-2">Payment</span>
//               </a>
//             </il>
//           </ul>

//         </div>
//       </div>
//     </div>
//     </div>
//   );
// }

// export default Sidebar;

function Sidebar() {
  return (
    <div className="Sidebar">
      <ul className="SidebarList">
      {SidebarData.map((val, key) => {
        return (
        <li 
          key={key} 
          className="row"
          id={window.location.pathname === val.link ? "active" : ""}
          onClick={ () => {
          window.location.pathname = val.link;
          }}
        >
        {" "}
        <div id="icon">{val.icon}</div>{" "} <div id="title">{val.title}</div>{" "}
        </li>
        ) 
        
      })}
      </ul>
    </div>
    
  );
}

export default Sidebar;